module.exports = __webpack_public_path__ + "static/media/member-img-2.e70f8e92.png";